import Zoom from './src/zoom.jsx';

export default Zoom;



/** WEBPACK FOOTER **
 ** ./index.js
 **/